import React, { useState } from 'react'
import ReactMarkdown from 'react-markdown'
import { Container, Row, Col } from 'react-bootstrap';
import Prism from 'prismjs';
import OnThisPage from './OnThisPage';
import TranslationTable from './TranslationTable';

import { styled } from 'redoc';

const CssBaseline = styled.div`
    font-size: 14px;
    font-family: Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    -webkit-font-smoothing: antialiased;
    padding: 40px;

    .anchor > [id] {
      position: relative;
      top: -78px;
      pointer-events: none;
    }

    .anchor a[href^="#"] {
      color: inherit;
    }

    .anchor a[href^="#"]:hover {
      text-decoration: none;
      border-bottom: 1px solid;
    }

    h1, h2, h3, h4 {
        font-weight: 400;
        font-family: Montserrat,sans-serif;
        font-size: 1.85714em;
        color: #27bbc5;       
    }

    h2, h3, h4 {
      margin-top: 1em;
      margin-bottom: 0.75em;
    }

    h2 {
        font-size: 1.57143em;
        color: black;
    }

    h3, h4 {
        font-size: 18px;
        color: #253137;
        font-weight: 600;
    }

    h4, h5 {
      font-size: 1.2em;
      font-weight: 600;
    }

    table {
      margin-bottom: 0.5rem;
      margin-top: 1rem;
      width: 100%;
      line-height: 1.42857;
    }

    table th {
      padding-bottom: 1rem;
      border-bottom: solid 2px #EEF1F2;      
    }

    table td {
      border-bottom: solid 1px #EEF1F2;
      margin-bottom: 1.75rem;
      padding-top: 0.25rem;
      padding-bottom: 0.25rem;
    }

    table code {
      word-break: inherit;
    }

    pre {
      background-color: #f9f9f9;
      border-radius: 3px;
      font-size: 85%;
      line-height: 1.45;
      overflow: auto;
      padding: 16px;
    }

    blockquote {
      background: white;
      border-left: 4px solid #27bbc5;
      margin: 1.5em 10px;
      padding: 1em 20px .1em 20px;
    }
`;

const Markdown = (props) => {

  const [content, setContent] = useState(null);

  if (props.match.mode === "private" && process.env.REACT_APP_DOCUMENTATION_MODE === "public")
  {      
    setContent(null);
  }
  else
  {
    fetch(`/doc/${props.match.params.mode}/${props.match.params.docname}.md`).then((response) => response.text()).then((text) => {
      setContent(text);
    })  
  }
  
  
  function CodeBlock(props) {
    var html = Prism.highlight(props.value, Prism.languages[props.language] || Prism.languages.clike, props.language);
    var cls = props.language && 'language-' + props.language;
    
    return (
      <pre>
      <code
      dangerouslySetInnerHTML={{__html: html}}
      className={cls}
      />
      </pre>
      )
    }
    
    const flatten = (text, child) => {
      return typeof child === 'string'
      ? text + child
      : React.Children.toArray(child.props.children).reduce(flatten, text)
    }
    
    const Heading = ({ level, children, ...props}) => {
      if (level > 3 || level === 1) return React.createElement('h' + level, props, children);
      
      const slug = getSlug(children);
      
      return (
        <div className='anchor'>
        <div id={slug} />
        {React.createElement('h' + level, props, <a href={`#${slug}`}>{children}</a>)}
        </div>
        );
    }

    const getSlug = (children) => {
      const childrenArray = React.Children.toArray(children)
      const text = childrenArray.reduce(flatten, '')
      return text.toLowerCase().replace(/\W/g, '-')
    }

  return (
        <CssBaseline>
            <Container fluid={true}>
                <Row>
                    <Col xl={2} lg={0} md={0}>
                    </Col>
                    <Col xl={7} lg={9} md={12}>
                        <ReactMarkdown source={content} escapeHtml={false} renderers={{code: CodeBlock, heading: Heading }} parserOptions={{commonmark: true}} />
                        {props.match.url === '/about/private/translation' && <TranslationTable />}
                    </Col>
                    <Col xl={3} lg={3} md={0} className="d-none d-sm-none d-md-none d-lg-block">
                        <OnThisPage content={content} slugify={getSlug} />
                    </Col>
                </Row>
            </Container>

        </CssBaseline>
    )
}

export default Markdown


// WEBPACK FOOTER //
// ./src/components/Markdown.js